'use strict';

import ngResource from 'angular-resource';

class SaRebootService {
  constructor($resource) {
    'ngInject';
    this.api = $resource(
      '/api/sa_reboot',
      {},
      {
        reboot: { method: 'POST', isArray: false }
      }
    );

    this.oem_api = $resource(
      '/api/oem/sa_reboot',
      {},
      {
        reboot: { method: 'POST', isArray: false }
      }
    )
  }
}

export default angular.module('leptonApp.SaRebootService', ['ngResource'])
  .service('SaRebootService', ['$resource', SaRebootService])
  .name;



// WEBPACK FOOTER //
// ./public/dev/components/api/sa_reboot/sa_reboot.service.js